import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import styled from 'styled-components';
import { withCalculator } from '@deerplusofficial/pos-hoc';
import { color } from '@deerplusofficial/pos-helper';

const Number = styled.input.attrs({ type: 'text', readOnly: true })`
  appearance: none;
  margin-left: auto;
  overflow: hidden;
  font-size: 36px;
  color: ${color.text.price};
  cursor: pointer;
  border: 0;
  outline: 0;
  background: none transparent;
  white-space: nowrap;
  text-align: right;
`;

class Price extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onKeyDown: PropTypes.func,
    onFocus: PropTypes.func,
  };

  static defaultProps = {
    value: '',
    onKeyDown: _.identity,
    onFocus: _.identity,
  };

  render() {
    const { value, onKeyDown, onFocus } = this.props;

    return (
      <Number
        value={value}
        size={_.size(value) + 1}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
      />
    );
  }
}

export default withCalculator()(Price);



// WEBPACK FOOTER //
// ./src/components/ProductModal/Price.js